import styled from 'styled-components';
import { typography } from '../../../typography/typography.js';

// Styled components for ExpandableParagraph
var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-ep7zoj-0"
})(["margin:8px 0 12px;color:", ";font-weight:", ";font-size:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.colorPalette.neutralColors.shade_light_1;
}, typography.fontWeightLight, typography.fontSize, function (_ref2) {
  var rootStyle = _ref2.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var ExpandedWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ExpandedWrapper",
  componentId: "sc-ep7zoj-1"
})(["display:block;margin:16px 0 16px 0;"]);
process.env.NODE_ENV !== "production" ? ExpandedWrapper.displayName = 'ExpandedWrapper' : void 0;
var TextButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__TextButton",
  componentId: "sc-ep7zoj-2"
})(["border:none;background:none;padding:0;margin:0;cursor:pointer;text-decoration:underline;font-stretch:normal;font-style:normal;line-height:1.5;font-family:", ";font-size:", ";font-weight:", ";color:", ";", ""], typography.fontFamily, typography.fontSize, typography.fontWeightLight, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colorPalette.primaryColors.main.shade_dark_2;
}, function (_ref4) {
  var buttonStyle = _ref4.buttonStyle;
  return buttonStyle;
});
process.env.NODE_ENV !== "production" ? TextButton.displayName = 'TextButton' : void 0;

export { ExpandedWrapper, Root, TextButton };
